/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';

/**
 * 
 * @export
 * @interface InternalApiEntityGroupScreeningConfiguration
 */
export interface InternalApiEntityGroupScreeningConfiguration {
    /**
     * 
     * @type {number}
     * @memberof InternalApiEntityGroupScreeningConfiguration
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiEntityGroupScreeningConfiguration
     */
    groupCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiEntityGroupScreeningConfiguration
     */
    excludeFromDailyScreening: boolean;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiEntityGroupScreeningConfiguration
     */
    createdBy?: InternalApiUserBasicDetails;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiEntityGroupScreeningConfiguration
     */
    updatedBy?: InternalApiUserBasicDetails;
}

/**
 * Check if a given object implements the InternalApiEntityGroupScreeningConfiguration interface.
 */
export function instanceOfInternalApiEntityGroupScreeningConfiguration(value: object): value is InternalApiEntityGroupScreeningConfiguration {
    if (!('groupCode' in value) || value['groupCode'] === undefined) return false;
    if (!('excludeFromDailyScreening' in value) || value['excludeFromDailyScreening'] === undefined) return false;
    return true;
}

export function InternalApiEntityGroupScreeningConfigurationFromJSON(json: any): InternalApiEntityGroupScreeningConfiguration {
    return InternalApiEntityGroupScreeningConfigurationFromJSONTyped(json, false);
}

export function InternalApiEntityGroupScreeningConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiEntityGroupScreeningConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'groupCode': json['groupCode'],
        'excludeFromDailyScreening': json['excludeFromDailyScreening'],
        'createdBy': json['createdBy'] == null ? undefined : InternalApiUserBasicDetailsFromJSON(json['createdBy']),
        'updatedBy': json['updatedBy'] == null ? undefined : InternalApiUserBasicDetailsFromJSON(json['updatedBy']),
    };
}

export function InternalApiEntityGroupScreeningConfigurationToJSON(json: any): InternalApiEntityGroupScreeningConfiguration {
    return InternalApiEntityGroupScreeningConfigurationToJSONTyped(json, false);
}

export function InternalApiEntityGroupScreeningConfigurationToJSONTyped(value?: InternalApiEntityGroupScreeningConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'groupCode': value['groupCode'],
        'excludeFromDailyScreening': value['excludeFromDailyScreening'],
        'createdBy': InternalApiUserBasicDetailsToJSON(value['createdBy']),
        'updatedBy': InternalApiUserBasicDetailsToJSON(value['updatedBy']),
    };
}

